import { useEffect } from 'react';

// Consolidated from 7 widget pagination containers' handleKeyDown/onKeyDown pair
// (docs/plans/consolidate-duplicate-functions-fsd, W4/C7). `isBlocked` and `isShowPagination`
// default to the "always attach the listener / never gate the shortcut" behavior used by the
// containers that don't have their own concept of either.
const usePaginationKeyboard = ({
  tabZoneId,
  isDisabled,
  isBlocked = false,
  isShowPagination = true,
  isDisabledPrev,
  isDisabledNext,
  onClickPrevious,
  onClickNext,
  pageStringRef,
  maxPageNumberRef,
  setPageIndex,
  setIsError,
  deps,
}: {
  tabZoneId: string;
  isDisabled: boolean;
  isBlocked?: boolean;
  isShowPagination?: boolean;
  isDisabledPrev: boolean;
  isDisabledNext: boolean;
  onClickPrevious: () => void;
  onClickNext: () => void;
  pageStringRef: { current: any };
  maxPageNumberRef: { current: any };
  setPageIndex: (updater: (prev: { index: number }) => { index: number }) => void;
  setIsError: (value: boolean) => void;
  deps: unknown[];
}) => {
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event?.repeat || isDisabled) {
        return;
      }
      const tabZone = document.getElementById(tabZoneId);
      if (tabZone && !tabZone.matches(':hover')) {
        return;
      }
      const { keyCode, ctrlKey, metaKey } = event;
      if (ctrlKey || metaKey) {
        return;
      }
      if (isShowPagination) {
        event.preventDefault();
        if (keyCode === 90) {
          // Z
          if (isDisabledPrev) return;
          onClickPrevious();
          return;
        }
        if (keyCode === 88) {
          // X
          if (isDisabledNext) return;
          onClickNext();
        }
      }
    };
    if (isBlocked) {
      window.removeEventListener('keydown', handleKeyDown);
    } else {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, deps);

  const onKeyDown = (e: any) => {
    e.stopPropagation();
    if (e.keyCode === 13 || e.code === 'Enter') {
      if (pageStringRef.current) {
        const pageNumber = Number(pageStringRef.current);
        if (pageNumber && pageNumber <= (maxPageNumberRef.current as number)) {
          const newPageIndex = Number(pageStringRef.current) - 1;
          setPageIndex((prev) => (newPageIndex !== prev.index ? { index: newPageIndex } : prev));
        } else {
          setIsError(true);
        }
      }
    }
  };

  return { onKeyDown };
};

export default usePaginationKeyboard;
